import(/* webpackMode: "eager" */ "/app/app/(public)/pricing/page.tsx");
